module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/ian_sara_lean_questioning-24f9edc84f6866578dbd17d6d194a844.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/ian_sara_lean_questioning.png
// module id = 902
// module chunks = 2